import ZingTouch from 'zingtouch';
import { getCardinalDirection } from '../shared/helpers/ZingTouchHelper';
import gsap from 'gsap';




export default class TrackBar {
	#root;
	#bar;
	#onChangeCall;
	#touchableRegion;
	
	constructor(element, touchableRegion = null) {
		this.#root = element;
		this.#touchableRegion = touchableRegion || element;
		this.#bar = element.querySelector('.ui-scroll-state--track');
		this.attachEvents();
	}
	
	
	attachEvents() {
		const _this = this;
		const useSwipe = false;
		
		if( useSwipe ) {
			const region = ZingTouch.Region(this.#touchableRegion, false, false);
			
			region.bind(this.#bar, 'pan', event => {
				// Within each of those special ZingTouch events, 
				// the originalEvent the browser emitted is stored.
				event.detail.events.forEach(e => {
					e.originalEvent.preventDefault();
				});
				
				const { currentDirection, distanceFromOrigin } = event.detail.data[0];
				const direction = getCardinalDirection(currentDirection);
				const distance = direction === 'W' ? distanceFromOrigin * -1 : distanceFromOrigin;
				const currentValue = gsap.getProperty(_this.#bar, 'width');
				const maxWidth = _this.#root.offsetWidth;
				const width = gsap.utils.clamp(0, maxWidth, currentValue + distance);
				
				gsap.to(_this.#bar, { 
					width: width,
					duration: .5,
					onUpdate: () => _this.triggerOnChange( (width / maxWidth) * 100 ),
				});
				
			}, false);
		}
		
		this.#root.addEventListener('click', event => {
			const position = (event.offsetX / this.#root.offsetWidth) * 100;
			_this.triggerOnChange(position);
		});
		
		
		
	}
	
	getPosition() {
		return (this.#bar.offsetWidth / this.#root.offsetWidth) * 100;
	}
	
	setPercentage(value) {
		const width = this.#root.offsetWidth * (value / 100);
		gsap.to(this.#bar, { width: width, duration: .25 });
	}
	
	onChange(callable) {
		this.#onChangeCall = callable;
	}
	
	triggerOnChange(position) {
		this.#onChangeCall && this.#onChangeCall(position);
	}
}